import glob from './index.js'

export = Object.assign(glob, { default: glob, glob })
